// Find the value of a parent field from the value of a field in a child object.
// Use this function for an array of objects that may have further nested arrays of objects.

// Description of function parameters:
// data - array of objects
// parentObjectKey - key of the object field corresponding to the value to be returned
// childObjectKey - the key of the object field whose corresponding value will be compared to childObjectValue to find the searched object
// childObjectValue - the value of the field in the child object for which the parent value is to be returned
// nestedArrayObjectKey - the key of an object field whose value is an array of objects

export const findParentValueInNestedArrayObject = (
  data: Array<Object>,
  parentObjectKey: string,
  childObjectKey: string,
  childObjectValue: string,
  nestedArrayObjectKey: string,
) => {
    let parentValue = '';
    const parentValueToReturn = '';

    const getValueInNestedArrayObject = (data: Array<Object>, childObjectValue: string, parentValueToReturn: string) => {
        if (!data) return;
        data.some((e) => {
            if (e[childObjectKey] == childObjectValue) {
              parentValue = parentValueToReturn;
              return;
            } else if (e[nestedArrayObjectKey]) {
              return getValueInNestedArrayObject(e[nestedArrayObjectKey], childObjectValue, e[parentObjectKey],);
            }
        });
    };

    getValueInNestedArrayObject(data, childObjectValue, parentValueToReturn);
    return parentValue;
};
